<script setup lang="ts">
import { X } from 'lucide-vue-next'

import AppLogoIcon from '@/components/AppLogoIcon.vue'
import { usePWA } from '@/composables/usePWA'

const { canInstall, isInstalled, install, dismiss } = usePWA()
</script>

<template>
  <transition
    enter-active-class="transition-all duration-[500ms] ease"
    leave-active-class="transition-all duration-[500ms] ease"
    enter-from-class="translate-y-full opacity-0"
    leave-to-class="translate-y-full opacity-0"
  >
    <div
      v-if="canInstall && !isInstalled"
      class="fixed max-w-5xl mx-auto bottom-4 left-4 right-4 flex items-center justify-between rounded-2xl bg-neutral-900 px-3.5 py-3 text-white shadow-lg dark:bg-neutral-800 dark:ring-1 dark:ring-white/10"
    >
      <div class="flex items-center gap-3">
        <AppLogoIcon class="size-8" />
        <div>
          <div class="text-sm font-semibold">Install App</div>
          <div class="text-xs opacity-70">Get a better experience</div>
        </div>
      </div>

      <div class="flex items-center gap-2">
        <button
          class="cursor-pointer rounded-full bg-white px-3 py-1.5 text-sm text-black dark:bg-neutral-100 dark:text-neutral-900"
          @click="install"
        >
          Install
        </button>
        <button class="ml-4 cursor-pointer text-white" @click="dismiss">
          <X class="h-5 w-6" />
        </button>
      </div>
    </div>
  </transition>
</template>
